import { render } from "./Managers.vue?vue&type=template&id=2ce1dba2"
import script from "./Managers.vue?vue&type=script&lang=js"
export * from "./Managers.vue?vue&type=script&lang=js"

import "./Managers.vue?vue&type=style&index=0&id=2ce1dba2&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__